import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import { Redirect } from 'react-router-dom';
import { Button } from 'antd';
import { gql } from '@apollo/client';

const CREATE_USER_EXAM = gql`
  mutation CreateUserExam($input: CreateUserExamInput!) {
    createUserExam(input: $input) {
      user {
        uuid
        examCredits
      }
      userExam {
        uuid
        userUuid
        productSlug
        score
        status
        startedAt
        finishedAt
      }
      errors {
        detail
      }
    }
  }
`;

const CreateUserExam = (props) => {
  const { productSlug } = props;
  const [createUserExam, { loading, data }] = useMutation(CREATE_USER_EXAM);

  if (data) {
    const {
      createUserExam: {
        userExam: { uuid: userExamUuid },
      },
    } = data;
    const examTo = reverse(routes.study.exam, { productSlug, userExamUuid });
    return <Redirect to={examTo} push />;
  }

  return (
    <Button
      data-aaa="takeExam"
      onClick={() => {
        createUserExam({ variables: { input: { productSlug } } });
      }}
      loading={loading}
    >
      Take exam
    </Button>
  );
};

export default CreateUserExam;
